/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sbp from '@sbp/sbp'
import { mapState, mapGetters } from 'vuex'
import ModalClose from '../../../../frontend/views/components/modal/ModalClose.vue'
import Tooltip from '../../../../frontend/views/components/Tooltip.vue'
import NotificationList from './NotificationList.vue'
import { logExceptNavigationDuplicated } from '../../../../frontend/views/utils/misc.js'

const __vue_script__ = {
  name: 'NotificationCard',
  components: {
    ModalClose,
    NotificationList,
    Tooltip
  },
  methods: {
    toggleTooltip () {
      this.$refs.tooltip.toggle()
    },
    handleSettingsClick () {
      this.$router.push({ path: '/user-settings/notifications' }).catch(logExceptNavigationDuplicated)
      this.toggleTooltip()
    },
    markAllNotificationsAsRead () {
      sbp('gi.notifications/markAllAsRead', this.currentGroupId)
    }
  },
  computed: {
    ...mapState([
      'currentGroupId'
    ]),
    ...mapGetters([
      'currentNotificationCount'
    ])
  }
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tooltip",
    {
      ref: "tooltip",
      attrs: {
        direction: "right",
        manual: true,
        opacity: 1,
        "aria-label": _vm.L("Show notifications"),
      },
    },
    [
      _vm._t("default"),
      _c("template", { slot: "tooltip" }, [
        _c(
          "div",
          {
            staticClass: "card c-card",
            attrs: {
              role: "dialog",
              "aria-label": _vm.L("Notifications"),
              "data-test": "notificationCard",
            },
          },
          [
            _c(
              "div",
              { staticClass: "c-header" },
              [
                _c(
                  "i18n",
                  { staticClass: "is-title-4", attrs: { tag: "h2" } },
                  [_vm._v("Notifications")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "is-icon-small c-settings-btn",
                    on: { click: _vm.handleSettingsClick },
                  },
                  [_c("i", { staticClass: "icon-cog" })]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "c-body" },
              [
                _c("notification-list", {
                  attrs: { variant: "compact" },
                  on: { select: _vm.toggleTooltip },
                }),
              ],
              1
            ),
            _vm.currentNotificationCount
              ? _c(
                  "div",
                  { staticClass: "c-footer" },
                  [
                    _c(
                      "i18n",
                      {
                        staticClass: "link",
                        attrs: {
                          tag: "button",
                          "data-test": "markAllAsRead_In_Tooltip",
                        },
                        on: { click: _vm.markAllNotificationsAsRead },
                      },
                      [_vm._v("Mark all as read")]
                    ),
                    _c(
                      "router-link",
                      {
                        staticClass: "link",
                        attrs: {
                          to: { query: { modal: "NotificationModal" } },
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.toggleTooltip($event)
                          },
                        },
                      },
                      [_c("i18n", [_vm._v("See all")])],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("modal-close", {
              staticClass: "c-close",
              attrs: { "aria-label": _vm.L("Close profile") },
              on: { close: _vm.toggleTooltip },
            }),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-764f8b26_0", { source: ".c-card[data-v-764f8b26] {\n  position: relative;\n  padding: 0 0 4rem;\n  color: var(--text_0);\n  max-width: 100vw;\n  border-radius: 3px;\n  width: 100vw;\n  box-shadow: none;\n}\n.c-card[data-v-764f8b26]:last-child {\n  margin-bottom: 0;\n}\n.is-active .c-card[data-v-764f8b26] {\n  animation: zoom 100ms both cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n@media screen and (max-width: 768px) {\n.is-active .c-card[data-v-764f8b26] {\n    animation-name: enterFromBottom;\n}\n}\n@media screen and (min-width: 769px), print {\n.c-card[data-v-764f8b26] {\n    margin-top: -0.5rem;\n    box-shadow: 0 0.5rem 1.25rem rgba(54, 54, 54, 0.3);\n    width: 25rem;\n    padding: 0;\n}\n.c-card[data-v-764f8b26]::before {\n    content: \"\";\n    position: absolute;\n    top: 1rem;\n    left: -0.5rem;\n    display: block;\n    width: 0;\n    z-index: 0;\n    border-top: 0.5rem solid transparent;\n    border-right: 0.5rem solid var(--background_0);\n    border-bottom: 0.5rem solid transparent;\n}\n}\n.c-close[data-v-764f8b26] {\n  left: calc(100vw - 4rem);\n  top: 1.5rem;\n}\n@media screen and (min-width: 769px), print {\n.c-close[data-v-764f8b26] {\n    left: auto;\n    right: 1rem;\n    opacity: 0;\n    pointer-events: none;\n}\n.c-close[data-v-764f8b26]:focus {\n    opacity: 1;\n}\n}\n.c-header[data-v-764f8b26],\n.c-footer[data-v-764f8b26] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.c-header[data-v-764f8b26] {\n  padding: 1rem 1rem 0.5rem;\n}\n.c-footer[data-v-764f8b26] {\n  border-top: 1px solid var(--general_1);\n  padding: 0.75rem 1rem;\n}\n.c-body[data-v-764f8b26] {\n  height: 18rem;\n  overflow: auto;\n  overscroll-behavior-y: contain;\n}\n.c-settings-btn .icon-cog[data-v-764f8b26] {\n  transform-origin: 49% 48%;\n}\n.c-settings-btn:hover .icon-cog[data-v-764f8b26], .c-settings-btn:focus .icon-cog[data-v-764f8b26] {\n  animation: cog-data-v-764f8b26 400ms forwards;\n}\n@keyframes cog-data-v-764f8b26 {\nto {\n    transform: rotate(180deg);\n}\n}\n\n/*# sourceMappingURL=NotificationCard.vue.map */", map: {"version":3,"sources":["frontend/views/containers/notifications/NotificationCard.vue","NotificationCard.vue"],"names":[],"mappings":"AAwEA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;ACvEA;ADyEA;EACA,gBAAA;ACvEA;AD2EA;EACA,6DAAA;ACzEA;AACA;ADuEA;IAGA,+BAAA;ACvEE;AACF;AACA;ADoDA;IAsBA,mBAAA;IACA,kDAAA;IACA,YAAA;IACA,UAAA;ACvEE;AD0EF;IACA,WAAA;IACA,kBAAA;IACA,SAAA;IACA,aAAA;IACA,cAAA;IACA,QAAA;IACA,UAAA;IACA,oCAAA;IACA,8CAAA;IACA,uCAAA;ACxEE;AACF;AD4EA;EACA,wBAAA;EACA,WAAA;ACzEA;AACA;ADsEA;IAKA,UAAA;IACA,WAAA;IACA,UAAA;IACA,oBAAA;ACxEE;AD0EF;IACA,UAAA;ACxEE;AACF;AD4EA;;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;ACzEA;AD4EA;EACA,yBAAA;ACzEA;AD4EA;EACA,sCAAA;EACA,qBAAA;ACzEA;AD4EA;EACA,aAAA;EACA,cAAA;EACA,8BAAA;ACzEA;AD6EA;EACA,yBAAA;AC1EA;AD6EA;EAEA,6CAAA;AC5EA;ADgFA;AACA;IAAA,yBAAA;AC5EE;AACF;;AAEA,+CAA+C","file":"NotificationCard.vue","sourcesContent":["<template lang='pug'>\ntooltip(\n  direction='right'\n  :manual='true'\n  ref='tooltip'\n  :opacity='1'\n  :aria-label='L(\"Show notifications\")'\n)\n  slot\n\n  template(slot='tooltip')\n    .card.c-card(role='dialog' :aria-label='L(\"Notifications\")' data-test='notificationCard')\n      .c-header\n        i18n.is-title-4(tag='h2') Notifications\n        button.is-icon-small.c-settings-btn(@click='handleSettingsClick')\n          i.icon-cog\n\n      .c-body\n        notification-list(variant='compact' @select='toggleTooltip')\n      .c-footer(v-if='currentNotificationCount')\n        i18n.link(tag='button'\n          @click='markAllNotificationsAsRead'\n          data-test='markAllAsRead_In_Tooltip'\n        ) Mark all as read\n\n        router-link.link(:to='{ query: { modal: \"NotificationModal\" }}' @click.native='toggleTooltip')\n          i18n See all\n\n      modal-close.c-close(:aria-label='L(\"Close profile\")' @close='toggleTooltip')\n</template>\n\n<script>\nimport sbp from '@sbp/sbp'\nimport { mapState, mapGetters } from 'vuex'\nimport ModalClose from '../../../../frontend/views/components/modal/ModalClose.vue'\nimport Tooltip from '../../../../frontend/views/components/Tooltip.vue'\nimport NotificationList from './NotificationList.vue'\nimport { logExceptNavigationDuplicated } from '../../../../frontend/views/utils/misc.js'\n\nexport default {\n  name: 'NotificationCard',\n  components: {\n    ModalClose,\n    NotificationList,\n    Tooltip\n  },\n  methods: {\n    toggleTooltip () {\n      this.$refs.tooltip.toggle()\n    },\n    handleSettingsClick () {\n      this.$router.push({ path: '/user-settings/notifications' }).catch(logExceptNavigationDuplicated)\n      this.toggleTooltip()\n    },\n    markAllNotificationsAsRead () {\n      sbp('gi.notifications/markAllAsRead', this.currentGroupId)\n    }\n  },\n  computed: {\n    ...mapState([\n      'currentGroupId'\n    ]),\n    ...mapGetters([\n      'currentNotificationCount'\n    ])\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n.c-card {\n  position: relative;\n  padding: 0 0 4rem;\n  color: $text_0;\n  max-width: 100vw;\n  border-radius: 3px;\n  width: 100vw;\n  box-shadow: none;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  // is-active is from tooltip\n  .is-active & {\n    animation: zoom 100ms both cubic-bezier(0.165, 0.84, 0.44, 1);\n    @include phone {\n      animation-name: enterFromBottom;\n    }\n  }\n\n  @include tablet {\n    margin-top: -0.5rem; // better aligned with bell icon\n    box-shadow: 0 0.5rem 1.25rem rgba(54, 54, 54, 0.3);\n    width: 25rem;\n    padding: 0;\n\n    // triangle corner\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 1rem;\n      left: -0.5rem;\n      display: block;\n      width: 0;\n      z-index: 0;\n      border-top: 0.5rem solid transparent;\n      border-right: 0.5rem solid $background;\n      border-bottom: 0.5rem solid transparent;\n    }\n  }\n}\n\n.c-close {\n  left: calc(100vw - 4rem);\n  top: 1.5rem;\n\n  @include tablet {\n    left: auto;\n    right: 1rem;\n    opacity: 0;\n    pointer-events: none;\n\n    &:focus {\n      opacity: 1;\n    }\n  }\n}\n\n.c-header,\n.c-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.c-header {\n  padding: 1rem 1rem 0.5rem;\n}\n\n.c-footer {\n  border-top: 1px solid $general_1;\n  padding: 0.75rem 1rem;\n}\n\n.c-body {\n  height: 18rem;\n  overflow: auto;\n  overscroll-behavior-y: contain;\n}\n\n.c-settings-btn {\n  .icon-cog {\n    transform-origin: 49% 48%;\n  }\n\n  &:hover .icon-cog,\n  &:focus .icon-cog {\n    animation: cog 400ms forwards;\n  }\n}\n\n@keyframes cog {\n  to { transform: rotate(180deg); }\n}\n</style>\n",".c-card {\n  position: relative;\n  padding: 0 0 4rem;\n  color: var(--text_0);\n  max-width: 100vw;\n  border-radius: 3px;\n  width: 100vw;\n  box-shadow: none;\n}\n.c-card:last-child {\n  margin-bottom: 0;\n}\n.is-active .c-card {\n  animation: zoom 100ms both cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n@media screen and (max-width: 768px) {\n  .is-active .c-card {\n    animation-name: enterFromBottom;\n  }\n}\n@media screen and (min-width: 769px), print {\n  .c-card {\n    margin-top: -0.5rem;\n    box-shadow: 0 0.5rem 1.25rem rgba(54, 54, 54, 0.3);\n    width: 25rem;\n    padding: 0;\n  }\n  .c-card::before {\n    content: \"\";\n    position: absolute;\n    top: 1rem;\n    left: -0.5rem;\n    display: block;\n    width: 0;\n    z-index: 0;\n    border-top: 0.5rem solid transparent;\n    border-right: 0.5rem solid var(--background_0);\n    border-bottom: 0.5rem solid transparent;\n  }\n}\n\n.c-close {\n  left: calc(100vw - 4rem);\n  top: 1.5rem;\n}\n@media screen and (min-width: 769px), print {\n  .c-close {\n    left: auto;\n    right: 1rem;\n    opacity: 0;\n    pointer-events: none;\n  }\n  .c-close:focus {\n    opacity: 1;\n  }\n}\n\n.c-header,\n.c-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.c-header {\n  padding: 1rem 1rem 0.5rem;\n}\n\n.c-footer {\n  border-top: 1px solid var(--general_1);\n  padding: 0.75rem 1rem;\n}\n\n.c-body {\n  height: 18rem;\n  overflow: auto;\n  overscroll-behavior-y: contain;\n}\n\n.c-settings-btn .icon-cog {\n  transform-origin: 49% 48%;\n}\n.c-settings-btn:hover .icon-cog, .c-settings-btn:focus .icon-cog {\n  animation: cog 400ms forwards;\n}\n\n@keyframes cog {\n  to {\n    transform: rotate(180deg);\n  }\n}\n\n/*# sourceMappingURL=NotificationCard.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-764f8b26"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "<template lang='pug'>\ntooltip(\n  direction='right'\n  :manual='true'\n  ref='tooltip'\n  :opacity='1'\n  :aria-label='L(\"Show notifications\")'\n)\n  slot\n\n  template(slot='tooltip')\n    .card.c-card(role='dialog' :aria-label='L(\"Notifications\")' data-test='notificationCard')\n      .c-header\n        i18n.is-title-4(tag='h2') Notifications\n        button.is-icon-small.c-settings-btn(@click='handleSettingsClick')\n          i.icon-cog\n\n      .c-body\n        notification-list(variant='compact' @select='toggleTooltip')\n      .c-footer(v-if='currentNotificationCount')\n        i18n.link(tag='button'\n          @click='markAllNotificationsAsRead'\n          data-test='markAllAsRead_In_Tooltip'\n        ) Mark all as read\n\n        router-link.link(:to='{ query: { modal: \"NotificationModal\" }}' @click.native='toggleTooltip')\n          i18n See all\n\n      modal-close.c-close(:aria-label='L(\"Close profile\")' @close='toggleTooltip')\n</template>\n\n<script>\nimport sbp from '@sbp/sbp'\nimport { mapState, mapGetters } from 'vuex'\nimport ModalClose from '../../../../frontend/views/components/modal/ModalClose.vue'\nimport Tooltip from '../../../../frontend/views/components/Tooltip.vue'\nimport NotificationList from './NotificationList.vue'\nimport { logExceptNavigationDuplicated } from '../../../../frontend/views/utils/misc.js'\n\nexport default {\n  name: 'NotificationCard',\n  components: {\n    ModalClose,\n    NotificationList,\n    Tooltip\n  },\n  methods: {\n    toggleTooltip () {\n      this.$refs.tooltip.toggle()\n    },\n    handleSettingsClick () {\n      this.$router.push({ path: '/user-settings/notifications' }).catch(logExceptNavigationDuplicated)\n      this.toggleTooltip()\n    },\n    markAllNotificationsAsRead () {\n      sbp('gi.notifications/markAllAsRead', this.currentGroupId)\n    }\n  },\n  computed: {\n    ...mapState([\n      'currentGroupId'\n    ]),\n    ...mapGetters([\n      'currentNotificationCount'\n    ])\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n.c-card {\n  position: relative;\n  padding: 0 0 4rem;\n  color: $text_0;\n  max-width: 100vw;\n  border-radius: 3px;\n  width: 100vw;\n  box-shadow: none;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  // is-active is from tooltip\n  .is-active & {\n    animation: zoom 100ms both cubic-bezier(0.165, 0.84, 0.44, 1);\n    @include phone {\n      animation-name: enterFromBottom;\n    }\n  }\n\n  @include tablet {\n    margin-top: -0.5rem; // better aligned with bell icon\n    box-shadow: 0 0.5rem 1.25rem rgba(54, 54, 54, 0.3);\n    width: 25rem;\n    padding: 0;\n\n    // triangle corner\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 1rem;\n      left: -0.5rem;\n      display: block;\n      width: 0;\n      z-index: 0;\n      border-top: 0.5rem solid transparent;\n      border-right: 0.5rem solid $background;\n      border-bottom: 0.5rem solid transparent;\n    }\n  }\n}\n\n.c-close {\n  left: calc(100vw - 4rem);\n  top: 1.5rem;\n\n  @include tablet {\n    left: auto;\n    right: 1rem;\n    opacity: 0;\n    pointer-events: none;\n\n    &:focus {\n      opacity: 1;\n    }\n  }\n}\n\n.c-header,\n.c-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.c-header {\n  padding: 1rem 1rem 0.5rem;\n}\n\n.c-footer {\n  border-top: 1px solid $general_1;\n  padding: 0.75rem 1rem;\n}\n\n.c-body {\n  height: 18rem;\n  overflow: auto;\n  overscroll-behavior-y: contain;\n}\n\n.c-settings-btn {\n  .icon-cog {\n    transform-origin: 49% 48%;\n  }\n\n  &:hover .icon-cog,\n  &:focus .icon-cog {\n    animation: cog 400ms forwards;\n  }\n}\n\n@keyframes cog {\n  to { transform: rotate(180deg); }\n}\n</style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__